export default {
    gameInfo: state => state,
};